import ByTitle from './ByTitle'
import withByTitle from './withByTitle'

const ConnectedByTitle = withByTitle(ByTitle)

export { ConnectedByTitle as ByTitle }
